import { render, staticRenderFns } from "./List.vue?vue&type=template&id=7ea6f440&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../hotel-wc-product/hotel-wc/sources/client/hotel-wc-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea6f440",
  null
  
)

export default component.exports